import Cookies from "js-cookie";
import api from "@/api";

export default {
  namespaced: true,
  state: () => ({
    user: {
      nickname: null,
      avatarUrl: null,
      uid: null,
    },
    token: null,
  }),
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setProfile(state, profile) {
      state.user.profile = profile;
    },
  },
  getters: {
    isLoggedIn(state) {
      return Boolean(state.user && state.user.uid);
    },
    isAdmin(state) {
      return state.user && state.user.role === "admin";
    },
  },
  actions: {
    async getUserInfo(context) {
      const token = Cookies.get("b.token");
      console.log("ssss", token);
      if (!token) {
        return null;
      }

      if (context.state.user && context.state.user.uid) {
        return context.state.user;
      }

      if (!context.state.token) {
        context.commit("setToken", token);
      }

      const res = await api.users.getUserProfile();
      if (res.data.success === true) {
        context.commit("setUser", res.data.data);
        return res.data.data;
      } else {
        Cookies.remove("b.token");
      }

      return null;
    },
    logout(context) {
      context.state.user = {};
      Cookies.remove("b.token");
      window.location.href = "/";
    },
  },
};
